export default "__VITE_ASSET__Dn5pAV5A__"